import React from 'react';
import { Box, Avatar, Typography, Paper } from '@mui/material';
import {
    getProfileAvatarUrl,
    getProfileDisplayName,
    getProfileAvatarLetter,
    nameToAvatarColor,
} from 'features/feature_job/utils/profileDisplay';

const ProfileDetails = ({ profile, onAvatarClick, onNameClick }) => {
    const displayName = getProfileDisplayName(profile);
    const avatarSrc = getProfileAvatarUrl(profile);

    return (
        <Paper elevation={1} className="p-4 mb-4">
            <Box display="flex" alignItems="center">
                <Avatar
                    src={avatarSrc || undefined}
                    alt={displayName}
                    onClick={onAvatarClick}
                    sx={{ 
                        width: 100, 
                        height: 100, 
                        marginRight: 3,
                        fontSize: '2.25rem',
                        fontWeight: 700,
                        bgcolor: nameToAvatarColor(displayName),
                        cursor: onAvatarClick ? 'pointer' : 'default',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        '&:hover': onAvatarClick ? {
                            transform: 'scale(1.05)',
                            boxShadow: 3
                        } : {}
                    }}
                >
                    {getProfileAvatarLetter(profile)}
                </Avatar>
                <Box>
                    <Typography
                        variant="h5"
                        className="mb-2"
                        component={onNameClick ? 'button' : 'div'}
                        type={onNameClick ? 'button' : undefined}
                        onClick={onNameClick}
                        sx={
                            onNameClick
                                ? {
                                      display: 'block',
                                      border: 'none',
                                      background: 'none',
                                      padding: 0,
                                      cursor: 'pointer',
                                      textAlign: 'left',
                                      fontFamily: 'inherit',
                                      color: 'text.primary',
                                      '&:hover': { color: 'primary.main', textDecoration: 'underline' },
                                  }
                                : undefined
                        }
                    >
                        {profile?.first_name} {profile?.last_name}
                    </Typography>
                    <Typography variant="body1" color="textSecondary" className="mb-1">
                        <i className="fi-rr-marker mx-1"></i>
                        {profile?.city || 'Location not specified'}
                        {profile?.country?.name && `, ${profile.country.name}`}
                    </Typography>
                    {profile?.phone_number && (
                        <Typography variant="body1" color="textSecondary" className="mb-1">
                            <i className="fi-rr-phone-call mx-1"></i>
                            {profile.phone_number}
                        </Typography>
                    )}
                    <Typography variant="body1" color="textSecondary">
                        <i className="fi-rr-envelope mx-1"></i>
                        {profile?.email || 'Email not specified'}
                    </Typography>
                </Box>
            </Box>
            {profile?.about && (
                <Box mt={3}>
                    <Typography variant="h6" className="mb-2">About</Typography>
                    <Typography variant="body1">{profile.about}</Typography>
                </Box>
            )}
        </Paper>
    );
};

export default ProfileDetails; 